// API Configuration
// For development: use http://localhost:3002
// For production: set REACT_APP_API_URL=https://api.sambhavpro.com in .env file
// commit this change

const isLocal = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const API_BASE_URL = 'https://api.sambhavpro.com';
// const API_BASE_URL = process.env.REACT_APP_API_URL ||
//   (isLocal ? 'http://localhost:3002' : 'https://api.sambhavpro.com');
const config = {
  API_BASE_URL: API_BASE_URL,
  VAPID_PUBLIC_KEY: process.env.REACT_APP_VAPID_PUBLIC_KEY || 'BDbZQjoNrDondw3vu4e7j804Tk-FWkD9mJnWDOCgYcSb7i8pJu232sBIrVmCQYixhcKXVoQJzsINiMFgDHlVIWA',
  RAZORPAY_KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_live_TWNuLgQiCHuDv2',
  // RAZORPAY_KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_TYIf4vVXXgqiLC',
  API_ENDPOINTS: {
    CONTACT: `${API_BASE_URL}/api/contact`,
    BOOKINGS: `${API_BASE_URL}/api/bookings`,
    LEADS: `${API_BASE_URL}/api/leads`,
    CRM_DEMO_LEADS: `${API_BASE_URL}/api/crm-demo-leads`,
    MARKETING_LEADS: `${API_BASE_URL}/api/marketing-leads`,
    LEADS_REMINDERS: `${API_BASE_URL}/api/leads/reminders/pending`,
    FACEBOOK_LEADS: `${API_BASE_URL}/api/facebook/leads`,
    FACEBOOK_LEADS_SYNC: `${API_BASE_URL}/api/facebook/leads/sync`,
    DASHBOARD: `${API_BASE_URL}/api/dashboard`,
    ACTIVITIES: `${API_BASE_URL}/api/activities`,
    FORM_CONFIG: `${API_BASE_URL}/api/form-config`,
    USERS: `${API_BASE_URL}/users`,
    VENDORS: `${API_BASE_URL}/api/vendors`,
    VENDOR_PLANS: `${API_BASE_URL}/api/vendor-plans`,
    VENDOR_SUBSCRIPTIONS: `${API_BASE_URL}/api/vendor-subscriptions`,
    MARKETPLACE: {
      PUBLISHABLE_LEADS: `${API_BASE_URL}/api/marketplace/admin/publishable-leads`,
      ADMIN_LEADS: `${API_BASE_URL}/api/marketplace/admin/leads`,
      ADMIN_PURCHASES: `${API_BASE_URL}/api/marketplace/admin/purchases`,
      ADMIN_DASHBOARD_STATS: `${API_BASE_URL}/api/marketplace/admin/dashboard-stats`,
      PRICING_PREVIEW: `${API_BASE_URL}/api/marketplace/admin/pricing-preview`,
      ADMIN_PRICING: `${API_BASE_URL}/api/admin/marketplace-pricing`,
      LEADS: `${API_BASE_URL}/api/marketplace/leads`,
      STATS: `${API_BASE_URL}/api/marketplace/stats`,
    },
    ADMIN_WALLET: {
      WALLETS: `${API_BASE_URL}/api/admin/vendor-wallet`,
      INVOICES: `${API_BASE_URL}/api/admin/vendor-wallet/invoices`,
      INVOICE_DETAIL: (id) => `${API_BASE_URL}/api/admin/vendor-wallet/invoices/${id}`,
      TRANSACTION_DETAIL: (id) => `${API_BASE_URL}/api/admin/vendor-wallet/transactions/${id}`,
      VENDOR_SUMMARY: (vendorId) => `${API_BASE_URL}/api/admin/vendor-wallet/${vendorId}/summary`,
      VENDOR_TRANSACTIONS: (vendorId) => `${API_BASE_URL}/api/admin/vendor-wallet/${vendorId}/transactions`,
      ADJUST: (vendorId) => `${API_BASE_URL}/api/admin/vendor-wallet/${vendorId}/adjust`,
    },
    AUTH: {
      LOGIN: `${API_BASE_URL}/api/auth/login`,
      REGISTER: `${API_BASE_URL}/api/auth/register`,
      ME: `${API_BASE_URL}/api/auth/me`,
      PROFILE: `${API_BASE_URL}/api/auth/profile`,
      VERIFY_TOKEN: `${API_BASE_URL}/api/auth/verify-token`,
      FORGOT_PASSWORD: `${API_BASE_URL}/api/auth/forgot-password`,
      RESET_PASSWORD: `${API_BASE_URL}/api/auth/reset-password`,
    },
    SETTINGS: {
      GENERAL: `${API_BASE_URL}/api/settings/general`,
      SECURITY: `${API_BASE_URL}/api/settings/security`,
      NOTIFICATIONS: `${API_BASE_URL}/api/settings/notifications`,
    },
    SUBSCRIPTIONS: {
      CURRENT: `${API_BASE_URL}/api/subscriptions/me`,
      STATS: `${API_BASE_URL}/api/subscriptions/stats`,
    },
    FCM: {
      REGISTER: `${API_BASE_URL}/api/fcm/register-token`,
      UNREGISTER: `${API_BASE_URL}/api/fcm/unregister-token`,
    },
    BILLING: {
      INVOICES: `${API_BASE_URL}/api/billing/invoices`,
      PAYMENT_METHODS: `${API_BASE_URL}/api/billing/payment-methods`,
    },
    PURCHASES: `${API_BASE_URL}/api/purchases`,
    GET_STARTED: `${API_BASE_URL}/api/purchases`,
    DUPLICATES: `${API_BASE_URL}/api/duplicates`,
    GENERATED_INVOICES: `${API_BASE_URL}/api/generated-invoices`,
    CLIENT_LEADS: `${API_BASE_URL}/api/client-leads`,
    NOTIFICATIONS: {
      LIST: `${API_BASE_URL}/api/notifications`,
      UNREAD_COUNT: `${API_BASE_URL}/api/notifications/unread-count`,
      MARK_READ: (id) => `${API_BASE_URL}/api/notifications/${id}/read`,
      MARK_ALL_READ: `${API_BASE_URL}/api/notifications/read-all`,
    },
  }
};

export default config;

